<template>
  <div class="lsbn">
    <div class="lsbn__bg" aria-hidden="true"></div>

    <div class="lsbn__logo">
      <router-link to="#">
        <img src="../../assets/img/logos/logo-hellowish-dark.webp" alt="HelloWish" />
      </router-link>
    </div>

    <div class="lsbn__body">

      <!-- ── Columna formulario ── -->
      <div class="lsbn__form-col">
        <h1 class="lsbn__title">
          <!-- Crea tu lista para usar nuestra <em>plantilla de nacimiento</em> -->
          Copia el checklist y adáptalo con tu propia lista
        </h1>
        <p class="lsbn__subtitle">
          Crea una lista para tu bebé con productos de cualquier tienda usando el checklist y HelloWish.
        </p>

        <div class="lsbn__inputs" :class="{ 'lsbn__inputs--compact': !showPassword }">
          <InputText
            label=""
            v-model="email"
            :errorLabel="emailError"
            placeholder="Tu email"
            ref="emailInput"
            @focus="emailError = ''"
            @keyup.native="showPassword = true"
          />
          <transition name="lsbn-reveal">
            <div v-if="showPassword" aria-live="polite">
              <InputText
                label=""
                v-model="password"
                type="password"
                :errorLabel="passwordError"
                placeholder="Contraseña"
                ref="passwordInput"
                @focus="passwordError = ''"
              />
              <div class="lsbn__legal">
                <span v-html="$t('signup.acceptTCpart1ImplicitVersion')"></span>
                <router-link
                  :to="$t('routes.confidentialityPolicy')"
                  style="text-decoration:underline;"
                  target="_blank"
                >{{ $t("signup.acceptTCpart2") }}</router-link>.
              </div>
            </div>
          </transition>
        </div>

        <bbButton
          class="button--accent button--block"
          label="Crear mi lista"
          @click="signUp"
          :loading="loading"
        />
        <p class="lsbn__reinforce">Usando el checklist</p>

        <login-social
          :show="true"
          :showFacebook="false"
          :showLabel="true"
          class="lsbn__social"
          color="yellow"
          size="large"
          origin="baby-needs-landing"
          listType="baby-registry"
          :verticalAlign="true"
          :beforeCallback="ssoBeforeCallback"
        />
      </div>

      <!-- ── Columna visual: mockup de móvil ── -->
      <div class="lsbn__visual">
        <div class="lsbn__phone">
          <div class="lsbn__phone-di"></div>
          <div class="lsbn__phone-screen">
            <img
              class="lsbn__screenshot"
              src="../../assets/img/covers/guest-full-screenshot.webp"
              alt=""
            />
          </div>
          <div class="lsbn__phone-home"></div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import LoginSocial from "../../components/ui/login/LoginSocial.vue";
import InputText from "../../components/forms/InputText.vue";
import bbButton from "../../components/buttons/bbButton.vue";
import axios from "axios";
const crypto = require("crypto");
import loginMixin from "../mixins/login.js";

export default {
  name: "LandingSignupBabyNeeds",
  mixins: [loginMixin],
  components: { LoginSocial, InputText, bbButton },
  metaInfo() {
    return {
      title: "Crea tu lista de nacimiento — HelloWish",
      meta: [{ name: "robots", content: "noindex" }],
    };
  },
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      emailError: "",
      passwordError: "",
      showPassword: false,
    };
  },
  computed: {
    isFormValid() {
      return this.email && this.password && this.validateEmail();
    },
    sourceListHash() {
      const isProd = process.env.API === 'https://hellobb-api.azurewebsites.net/api';
      return isProd ? 'ERnM' : 'lxA6';
    },
  },
  methods: {
    async signUp() {
      this.email = this.email.trim();
      this.emailError = "";
      this.passwordError = "";

      if (!this.email) {
        this.emailError = "Introduce tu email";
        return;
      }
      if (!this.validateEmail()) {
        this.emailError = "El email no es válido";
        return;
      }
      if (!this.showPassword) {
        this.showPassword = true;
        this.$nextTick(() => {
          const el = this.$refs.passwordInput?.$el?.querySelector("input");
          if (el) el.focus();
        });
        return;
      }
      if (!this.password) {
        this.passwordError = "Introduce una contraseña";
        return;
      }

      this.loading = true;

      let source_url = "";
      try { source_url = localStorage.getItem("source_url"); } catch (e) {}

      const baseURL = process.env.API;
      try {
        await axios.post(`${baseURL}/user/signup`, {
          email: this.email,
          password: this.password,
          SignupOrigin: "baby-needs-landing",
          listType: "baby-registry",
          referralUrl: source_url,
          language: "es-ES",
        });
        this.setModalShownCookie();
      } catch (error) {
        this.loading = false;
        if (parseInt(error.response?.status) === 409) {
          this.emailError = "Este email ya está registrado. ¿Quieres iniciar sesión?";
          await this.$sleep(this.goToLogin, 2000);
        }
        return;
      }

      window.mixpanel?.people?.set?.("Signup Origin", "baby-needs-landing");
      this.$root?.trackConversion?.({ email: this.email });
      return this.login(`/onboarding/baby-registry?onboardingSteps=date-only&sourceListHash=${this.sourceListHash}`);
    },

    validateEmail() {
      const email = (this.email || "").toLowerCase();
      const parts = email.split("@");
      if (parts.length !== 2) return false;
      const [left, right] = parts;
      return left.match(/^\w+([.-_+]\w+)*$/) && right.match(/^\w+([.-]\w+)*\.\w{2,10}$/);
    },

    setModalShownCookie() {
      const days = 30;
      const exp = new Date();
      exp.setDate(exp.getDate() + days);
      const hash = crypto.createHash("sha256")
        .update(new Date().getTime().toString() + Math.random().toString())
        .digest("hex");
      document.cookie = `modalShown=${hash}; expires=${exp.toUTCString()}; path=/`;
    },

    async goToLogin() {
      await this.$router.push({ name: "login" });
    },
    ssoBeforeCallback(next) {
      try {
        sessionStorage.setItem('onboardingSteps', 'date-only');
        sessionStorage.setItem('sourceListHash', this.sourceListHash);
      } catch (e) {}
      return next();
    },
  },
};
</script>

<style>
/* ── Contenedor ──────────────────────────────────────────── */
.lsbn {
  min-height: 100svh;
  background: #FFCC00;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 32px 24px 56px;
}

/* ── Fondo decorativo ────────────────────────────────────── */
.lsbn__bg {
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
.lsbn__bg::before,
.lsbn__bg::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.07);
}
.lsbn__bg::before { width: 360px; height: 360px; top: -120px; right: -100px; }
.lsbn__bg::after  { width: 280px; height: 280px; bottom: -100px; left: -80px; }

/* ── Logo ────────────────────────────────────────────────── */
.lsbn__logo {
  align-self: flex-start;
  flex-shrink: 0;
  margin-bottom: 32px;
  z-index: 1;
  position: relative;
}
.lsbn__logo img { width: 120px; height: auto; display: block; }

/* ── Body: form + visual ─────────────────────────────────── */
.lsbn__body {
  display: flex;
  flex-direction: column;
  gap: 48px;
  position: relative;
  z-index: 1;
}

/* ── Columna formulario ──────────────────────────────────── */
.lsbn__form-col {
  display: flex;
  flex-direction: column;
}

.lsbn__title {
  font-size: clamp(28px, 7vw, 44px);
  font-weight: 700;
  color: #312A5E;
  line-height: 1.2;
  letter-spacing: -1.5px;
  margin-bottom: 14px;
}
.lsbn__title em { font-style: normal; color: #fff; }

.lsbn__subtitle {
  font-size: 16px;
  color: #312A5E;
  opacity: 0.8;
  line-height: 1.6;
  margin-bottom: 24px;
}

.lsbn__inputs { margin-bottom: 14px; }
.lsbn__inputs--compact { margin-bottom: 4px; }

.lsbn__legal {
  font-size: 12px;
  color: #312A5E;
  opacity: 0.7;
  margin-top: 10px;
  line-height: 1.5;
}

.lsbn__reinforce {
  font-size: 13px;
  color: #312A5E;
  opacity: 0.65;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 0;
  padding-left: 8px;
}

.lsbn__social { margin-top: 4px !important; }
.lsbn__social ::v-deep .social-login__o span { background-color: #FFCC00; }

/* ── Transición password ─────────────────────────────────── */
.lsbn-reveal-enter-active,
.lsbn-reveal-leave-active {
  transition: max-height 0.4s ease, opacity 0.4s ease;
  overflow: hidden;
}
.lsbn-reveal-enter,
.lsbn-reveal-leave-to { max-height: 0; opacity: 0; }
.lsbn-reveal-enter-to,
.lsbn-reveal-leave { max-height: 200px; opacity: 1; }

/* ── Visual: mockup ──────────────────────────────────────── */
.lsbn__visual {
  display: flex;
  justify-content: center;
  align-items: center;
}

.lsbn__phone {
  width: 220px;
  background: #1C1C1E;
  border-radius: 48px;
  padding: 14px 10px 18px;
  box-shadow:
    0 0 0 1.5px #3a3a3c,
    inset 0 0 0 1px rgba(255,255,255,0.06),
    0 32px 80px rgba(49, 42, 94, 0.3),
    0 8px 24px rgba(0, 0, 0, 0.2);
  flex-shrink: 0;
}
.lsbn__phone-di {
  width: 80px;
  height: 20px;
  background: #000;
  border-radius: 20px;
  margin: 0 auto 8px;
}
.lsbn__phone-screen {
  border-radius: 30px;
  overflow-y: scroll;
  overflow-x: hidden;
  aspect-ratio: 9 / 19.5;
  background: #f5f5f5;
  /* scrollbar invisible */
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.lsbn__phone-screen::-webkit-scrollbar { display: none; }

.lsbn__screenshot {
  width: 100%;
  height: auto;
  display: block;
}
.lsbn__phone-home {
  width: 90px;
  height: 4px;
  background: rgba(255,255,255,0.25);
  border-radius: 4px;
  margin: 12px auto 0;
}


/* ── Desktop ─────────────────────────────────────────────── */
@media (min-width: 1024px) {
  .lsbn {
    flex-direction: row;
    align-items: center;
    gap: 64px;
    padding: 80px 10%;
  }
  .lsbn__logo { align-self: flex-start; margin-bottom: 0; }
  .lsbn__logo img { width: 140px; }
  .lsbn__body {
    flex: 1;
    flex-direction: row;
    align-items: center;
    gap: 80px;
  }
  .lsbn__form-col {
    flex: 1;
    max-width: 460px;
  }
  .lsbn__visual { flex-shrink: 0; }
  .lsbn__phone { width: 260px; }
}
</style>
